import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import { getCookie } from 'srcReact/helpers/utils'
import { loginConstants as lc } from 'srcReact/LoginPage'
import { authenticationConstants as authC } from 'srcReact/redux/constants/authentication'

const user = isUserAuthorized() && JSON.parse(localStorage.getItem('user'))

const initialState = user ? { loggedIn: true, logged: true, user, loading: false, error: null } : {}

export function login(state = initialState, action) {
  switch (action.type) {
    // case lc.LOGIN_SET_PICTURE:
    //   return {
    //     ...state,
    //     user: { ...state.user, picture: action.picture }
    //   }
    case lc.LOGIN_SET_PICTURE_URL:
      const updatedUser = {
        ...state.user,
        profile_picture: action.url,
        original_tag: action.originalTag,
        is_original: action.isOriginal,
        mime_type: action.mimeType
      }
      localStorage.setItem('user', JSON.stringify(updatedUser))
      return {
        ...state,
        user: updatedUser
      }

    // Login
    case lc.LOGIN_REQUEST:
      return {
        ...state,
        loggingIn: true,
        user: action.user,
        error: null,
        loading: true
      }
    case lc.LOGIN_SUCCESS:
      if (localStorage.hasOwnProperty('user_id')) {
        localStorage.removeItem('user_id')
      }
      return {
        ...state,
        loggedIn: true,
        logged: true,
        user: action.user,
        loading: false
      }

    case lc.GET_CURRENT_PROFILE_REQUEST:
      return {
        ...state
      }
    case lc.GET_CURRENT_PROFILE_SUCCESS:
      return { ...state, user: action.user }

    // failures
    case lc.GET_CURRENT_PROFILE_FAILURE:
    case lc.LOGIN_FB_FAILURE:
    case lc.LOGOUT_REQUEST: {
      return {
        ...state
      }
    }
    case lc.LOGOUT_SUCCESS: {
      return {
        ...state
      }
    }
    case lc.LOGOUT_FAILURE: {
      return {
        ...state
      }
    }

    case lc.LOGIN_FAILURE: {
      return {
        ...state,
        error: action.error,
        loading: false
      }
    }

    case authC.CREATE_ACCOUNT_SUCCESS:
      if (localStorage.hasOwnProperty('user_id')) {
        localStorage.removeItem('user_id')
      }
      return {
        loggedIn: true,
        logged: true,
        user: action.response.user
      }
    case lc.CHECK_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case lc.CHECK_EMAIL_SUCCESS: {
      const ssoOrgList = action.response.organizations.filter((x) => x.idp_id !== 1) // id 1 is always mixr
      if (ssoOrgList && ssoOrgList.length > 0) {
        //this local storage value is used on last screen of create account page, to show organization name
        //it is removed after account is created successfully
        localStorage.setItem('ssoOrgList', JSON.stringify(ssoOrgList))
      }
      return {
        ...state,
        ...action.response,
        loading: false
      }
    }
    case lc.CHECK_EMAIL_FAILURE:
      return {
        ...state,
        loading: false
      }

    case lc.LOGIN_WITH_WP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      }
    case lc.LOGIN_WITH_WP_SUCCESS:
      return {
        ...state,
        ...action.response,
        loading: false
      }
    case lc.LOGIN_WITH_WP_FAILURE:
      return {
        ...state,
        loading: false
      }
    case lc.SET_USER_NAME: {
      const { firstname, lastname } = action
      const user = localStorage.getItem('user')
      if (user) {
        let parsedUser = JSON.parse(user)
        parsedUser = { ...parsedUser, firstname: firstname, lastname: lastname }
        localStorage.setItem('user', JSON.stringify(parsedUser))
      }
      return {
        ...state,
        user: {
          ...state.user,
          firstname: firstname,
          lastname: lastname
        }
      }
    }

    default:
      return state
  }
}
